"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachPebble = function SvgBeachPebble(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.603 3.213c-1.484-1.027-3.774-1.5-4.443-.583h.009c-.337.466-.12 1.279.358 2.117-1.211-.204-3.392.985-5.215 2.834l-.427.43c-2.114 2.134-3.645 3.678-2.922 5.467.492 1.21 1.078 1.74 1.733 1.819-1.185.885-2.119 1.983-2.699 3.217-.519 1.11-.16 3.073 2.814 3.073h14.313c3.092 0 3.33-1.962 2.812-3.073-.675-1.44-1.829-2.694-3.303-3.64 1.606.458 2.9.369 3.303-2.895.296-2.397-1.344-3.36-4.488-3.73a8.248 8.248 0 0 0-.49-.043c.236-.12.424-.327.547-.642.949-2.454-.145-3.18-1.455-4.05a25.412 25.412 0 0 1-.446-.3h-.001Zm.024 5.004c-.603-.178-1.267-.54-1.88-.969a7.027 7.027 0 0 1-1.177-1.07c.1 1.014-.385 2.158-1.164 3.315 1.008-.729 2.662-1.166 4.22-1.276h.001Zm-6.692 4.206a28.14 28.14 0 0 0 1.552-1.706 1.408 1.408 0 0 0-.032.17h-.009c-.117.972.63 1.633 1.731 2.12l-.21-.001c-1.566 0-3.052.27-4.394.755.447-.41.902-.871 1.362-1.338Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachPebble);
var _default = exports["default"] = Memo;